import User from "@mapmycustomers/shared/types/User";
import { isDefined } from "@mapmycustomers/shared/util/assert";

import UserIdAvatarPair from "../type/UserIdAvatarPair";

const parseUserAvatarsBase64 = (users: User[], callback: (pairs: UserIdAvatarPair[]) => void) => {
  const canvas: HTMLCanvasElement = document.createElement("CANVAS") as HTMLCanvasElement;
  canvas.width = 32;
  canvas.height = 32;
  const promises: Promise<undefined | UserIdAvatarPair>[] = [];

  users.forEach(async (user) => {
    if (user.profilePhoto?.publicURI) {
      promises.push(
        (async () => {
          try {
            const response = await fetch(`${user.profilePhoto!.publicURI!}?${Date.now()}`, {
              mode: "cors",
            });
            const image = await response.blob();
            const imageBitmap = await createImageBitmap(image);

            canvas!.getContext("2d")!.drawImage(imageBitmap, 0, 0, 32, 32);
            return { avatar: canvas.toDataURL(), userId: user.id };
          } catch {
            // skip user images that can't be loaded
            return undefined;
          }
        })()
      );
    }
  });

  Promise.all(promises).then((pairs) => callback(pairs.filter(isDefined)));
};

export default parseUserAvatarsBase64;
